import type {
  CustomColumnField,
  DimensionField,
  GroupingField,
  MeasureField,
  MetricField,
  ReportField,
} from "../../../../../../../../../api/types/svTypes.ts";
import PinIcon from "@entrilia/shared/icons/PinIcon.tsx";
import NoPivotIcon from "./NoPivotIcon.tsx";
import ReverseSignIcon from "@entrilia/shared/icons/ReverseSignIcon.tsx";
import { getTabularFieldGridId } from "../../../../../utilities/getTabularFieldGridId.ts";
import type { FieldCaptionIcon } from "./FieldsCaptionIconSetContainer.tsx";

export const getDimensionIconSet = (
  field: DimensionField,
  freezedColumns: string[],
  grouping: GroupingField[],
  showGroupedColumns: boolean
) => {
  const result: FieldCaptionIcon[] = [];

  if (isFreezed(field, freezedColumns, grouping, showGroupedColumns)) {
    result.push({
      toolTipTitle: "Freezed Column",
      Icon: <PinIcon color="primary" sx={{ fontSize: "1rem" }} />,
    });
  }
  return result;
};

export const getMeasureIconSet = (field: MeasureField | MetricField | CustomColumnField, freezedColumns: string[]) => {
  const result: FieldCaptionIcon[] = [];
  if (field.config.standalone) {
    result.push({
      toolTipTitle: "Not Pivoted Field",
      Icon: <NoPivotIcon color="primary" sx={{ fontSize: "1rem" }} />,
    });
  }
  if (field.config.reverseSign) {
    result.push({
      toolTipTitle: "Reverse Sign",
      Icon: <ReverseSignIcon color="primary" sx={{ fontSize: "1rem" }} />,
    });
  }
  if (isFreezed(field, freezedColumns, [], false)) {
    result.push({
      toolTipTitle: "Freezed Column",
      Icon: <PinIcon color="primary" sx={{ fontSize: "1rem" }} />,
    });
  }
  return result;
};

const isFreezed = (
  field: ReportField,
  freezedColumns: string[],
  grouping: GroupingField[],
  showGroupedColumns: boolean
) => {
  return freezedColumns.some((f) => f === getTabularFieldGridId(field, grouping, showGroupedColumns));
};
